import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Controller, useForm } from 'react-hook-form'
import { Input } from '@navent-jobs/ui-kit/components/input'
import { Container, CustomIcon, CustomButton, CustomForm } from './mixins'
import { AppStore } from '../../../../../../../store'
import { resetCoupon, setCoupon } from '../../../../../../../store/coupon/actionsToDo'
import { CouponSuccess } from '../CouponSuccess'
import { Props } from '../../interface'
import { ValorizedCartState } from '../../../../../../../store/cart-v2/valorized/types'
import { postCartValorized } from '../../../../../../../store/cart-v2/valorized/actionsToDo'
import { CouponState } from '../../../../../../../store/coupon/types'
import { mapError } from './utils'
import { showSnackbarError } from '../../../../../../../store/snackbar/actions'
import { NewEcommerceDataLayers } from '../../../../../../../constants/gtm-events/gtm-events-new-ecommerce'
import { ModalCartState } from '../../../../../../../store/cart-v2/modal/types'

export const CouponInput = ({ isInputVisible, setIsInputVisible }: Props) => {
  const dispatch = useDispatch()
  const { couponCode, fetchCoupon } = useSelector<AppStore, CouponState>(({ couponStore }) => couponStore)
  const { cart, statusCart } = useSelector<AppStore, ValorizedCartState>(({ cartStoreV2 }) => cartStoreV2.valorized)
  const { open: showCart } = useSelector<AppStore, ModalCartState>(({ cartStoreV2 }) => cartStoreV2.modal)
  const buttonOptions = { size: 'small', type: 'outline', block: 'true' }
  const { t } = useTranslation()
  const { handleSubmit, control, errors, watch, setError, clearErrors } = useForm({
    defaultValues: { couponName: fetchCoupon.couponCode ?? '' },
  })
  const watchInput = watch()
  const submit = () => {
    const extraParams = { couponCode: watchInput.couponName }
    dispatch(setCoupon(watchInput.couponName))
    dispatch(postCartValorized(cart.items, extraParams))
  }

  useEffect(() => {
    if (couponCode && statusCart.success) {
      NewEcommerceDataLayers.cuponAplicado(couponCode)
    }
  }, [statusCart.success])

  useEffect(() => {
    if (statusCart.error) {
      setError('couponName', {
        type: 'api',
        message: mapError(statusCart.error),
      })
      dispatch(resetCoupon())
      // se muestra snack de error cuando el carrito esta cerrado y el error es 500
      statusCart.error === 500 && !showCart && dispatch(showSnackbarError(t('Hubo un error, intente luego')))
    }
  }, [statusCart.error])

  return (
    <Container>
      {statusCart.success && couponCode ? (
        <CouponSuccess isInputVisible={isInputVisible} setIsInputVisible={setIsInputVisible} couponName={couponCode} />
      ) : (
        <CustomForm id="couponForm" onSubmit={handleSubmit(submit)}>
          <Controller
            control={control}
            name="couponName"
            rules={{ required: { value: true, message: t('ecommerce.coupon.placeholder') } }}
            render={({ onChange, value }) => (
              <Input
                id="couponName"
                type="text"
                name="couponName"
                value={value}
                onChange={onChange}
                onFocus={() => clearErrors()}
                placeholder={t('ecommerce.coupon.placeholder')}
                fieldOptions={{
                  label: 'Cupón de descuento',
                  size: 'medium',
                  variant: 'darken',
                  maxLength: 15,
                  before: <CustomIcon name="icon-bold-price-tag" />,
                }}
                errors={errors}
              />
            )}
          />
          <CustomButton type="submit" isLoading={statusCart.loading} form="couponForm" buttonoptions={buttonOptions}>
            {t('Aplicar')}
          </CustomButton>
        </CustomForm>
      )}
    </Container>
  )
}
